


import React from 'react'
import { renderRichtext } from '../../lib/utils/renderRichtext'


export const TextTableRow = ({ blok }) => {


    const tableCellStyles = { border: '1px solid black', padding: '8px' }

    return (
        <tr>
            <td style={tableCellStyles}>

                {renderRichtext(blok.leftColumn)}

            </td>
            <td style={tableCellStyles}>

                {renderRichtext(blok.rightColumn)}

            </td>
        </tr>
    )
}
